import { render, staticRenderFns } from "./VideoComposition.vue?vue&type=template&id=0277c4bd&scoped=true&"
import script from "./VideoComposition.vue?vue&type=script&lang=ts&"
export * from "./VideoComposition.vue?vue&type=script&lang=ts&"
import style0 from "./VideoComposition.vue?vue&type=style&index=0&id=0277c4bd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0277c4bd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VCard,VCardText,VProgressLinear,VResponsive})
